// src/components/cards/CardSectionLabel.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Shared section label for all card components.
 * Renders a lightweight uppercase label with an optional right-side action (e.g. VIEW ALL, expand icon).
 */
const CardSectionLabel = ({ label, action, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: 1,
      cursor: onClick ? 'pointer' : 'default',
    }}
  >
    <Typography
      sx={{
        fontSize: '0.6rem',
        fontWeight: 500,
        letterSpacing: '1px',
        color: 'text.disabled',
        textTransform: 'uppercase',
        userSelect: 'none',
      }}
    >
      {label}
    </Typography>
    {action && (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {action}
      </Box>
    )}
  </Box>
);

export default CardSectionLabel;
